<template>
    <div>
        <Toolbar v-if="this.$route.name != 'NotFound' " />
        <main>
           <router-view></router-view>
        </main>
    </div>
</template>

<style>

 
main {  
    width: 80vw;
    margin: auto;
    padding-top: 1em;
    text-align: center;
    align-content: center;
    align-items: center;
    align-self: center;
}

    main h1 {
        font-size: 5vh;
        font-weight: 400;
        text-transform: none;
        margin: 3em auto 1.3em auto;
    }

  main h3 {
        font-size: 2.5vh;
        font-weight: 400;
        color: #888;
        text-transform: none;
        margin: 0.5em auto 2em auto;
  }

.captcha {
  margin: 3em auto;
}

@media screen and (max-width: 420px) {    
main {
    width: 100%;
}

    main h3 {
        /* margin: 0.54em; */
        margin-bottom: 1.5em;
    }

.header {  
    text-align: center;
}

    .header .logo {
        margin: 2vh auto;
        left: 0;
        right: 0;
    }
}

.text-green {    
    color: #7fc241;
}

.text-orange {    
    color: #f1b016;
}

.text-success {    
    color: #007A5E;
}

.text-warning {    
    color: #f68b1e;
}

.text-danger {    
    color: #ed4933;
}

.block {
    display: block;
}

@media screen and (max-width: 380px) {    
    main h1 {
        font-size: 2em;
        margin: 2.7em auto 1em auto;
    }
}
</style>


<script>
import Toolbar from './Toolbar'
// import axios from 'axios'
export default {
    name: 'Layout',
    components: { Toolbar }
  // data () {
  //   return {
  //     inputs: [
  //       {
  //         type: 'text',
  //         label: 'Número de documento del cotizante',
  //         value: ''
  //       },
  //       {
  //         type: 'text',
  //         label: 'Número de documento del aportante',
  //         value: ''
  //       }
  //     ],
  //     submitDisabled: true,
  //     sumbitText: 'Descargar'
  //   }
  // },
}
</script>
